import React from "react";
// core components
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";

function ViewMultaNaoAcompanhada(props) {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const [year, month, day] = dateString.split("T")[0].split("-");
    return `${day}/${month}/${year}`;
  };

  function formataValor(valor) {
    return parseFloat(valor).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
  }

  const clickCadastarMulta = (codPedido) => {
    props.props.history.push({
      pathname: `multas-nao-acompanhadas/cadastrar-multa`,
      state: { idPedido: codPedido }
    });
  }

  return (
    <>
      <div style={{ paddingTop: "35px" }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Pedido</TableCell>
                <TableCell align="center">Data Compra</TableCell>
                <TableCell align="center">Valor</TableCell>
                <TableCell align="center">Forma de Pagamento</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.solicitacoes.map((rec, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell component="th" scope="row">
                      {rec.TransactionId}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      {rec.DataTransacao ? formatDate(rec.DataTransacao) : "-"}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {formataValor(rec.Amount)}
                    </TableCell>
                    <TableCell component="th" scope="row" align="center">
                      {rec.FormaPgto}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
}
export default ViewMultaNaoAcompanhada;
